import addCopyShader from './CopyShader';
import addFXAAShader from './FXAAShader';

export {
    addCopyShader,
    addFXAAShader
}

export default {
    addCopyShader,
    addFXAAShader
}